import { render } from "./Reclamos.vue?vue&type=template&id=70972e7f&scoped=true"
import script from "./Reclamos.vue?vue&type=script&lang=js"
export * from "./Reclamos.vue?vue&type=script&lang=js"

import "./Reclamos.vue?vue&type=style&index=0&id=70972e7f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70972e7f"]])

export default __exports__